import { useContent } from "../../i18n";
import "./style.scss";

export const AboutUs = () => {
  const { about } = useContent();

  return (
    <div id="about" className="about-wrapper">
      <div className="container">
        <h2>{about.title}</h2>

        <div className="about-wrapper-container">
          <div className="about-icon">
            <img src="/assets/about-icon.png" alt="" />
          </div>
          <div className="about-text">
            {about.paras.map((para) => (
              <p key={para}>{para}</p>
            ))}
            <p>
              <span>{about.leadStrong}</span>
              {about.lead}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
